/* Muria Foods — Shopify Theme JS */

document.addEventListener('DOMContentLoaded', () => {

  // ── Sticky nav scroll class ──────────────────────────────────
  const nav = document.querySelector('.site-nav');
  if (nav) {
    const onScroll = () => {
      nav.classList.toggle('scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── Mobile menu toggle ───────────────────────────────────────
  const menuOpen  = document.getElementById('nav-open');
  const menuClose = document.getElementById('nav-close');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuOpen && menuClose && mobileMenu) {
    menuOpen.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    menuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Intersection Observer — reveal on scroll ─────────────────
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.delay || 0;
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'none';
          }, parseInt(delay));
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      observer.observe(el);
    });
  }

  // ── PDP Gallery (contain/cover aware) ───────────────────────
  const mainImg   = document.getElementById('pdp-main-img');
  const mainStage = document.getElementById('pdp-main-stage');
  const thumbs    = document.querySelectorAll('.pdp-gallery__thumb');
  if (mainImg && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        mainImg.src = thumb.dataset.src;
        const isCover = thumb.dataset.cover === 'true';
        mainImg.classList.toggle('pdp-main-cover', isCover);
        mainImg.classList.toggle('float-slow', !isCover);
        // match stage background to the thumb's bg
        if (mainStage) mainStage.style.backgroundColor = thumb.style.backgroundColor;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // ── Quantity stepper ────────────────────────────────────────
  const qtyInput = document.getElementById('pdp-qty');
  if (qtyInput) {
    document.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1') - 1);
    });
    document.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value || '1') + 1;
    });
  }

  // ── PDP uses tabs (hover/click to activate) ─────────────────
  const useTabs = document.querySelectorAll('[data-use-tab]');
  if (useTabs.length) {
    useTabs.forEach(tab => {
      const activate = () => {
        useTabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
      };
      tab.addEventListener('mouseenter', activate);
      tab.addEventListener('click', activate);
      tab.addEventListener('focus', activate);
    });

    // On mobile the tabs stack full-width, so instead of hover, whichever
    // box sits nearest the vertical center of the screen becomes active
    // as the user scrolls — reversible in both directions.
    if (window.matchMedia('(max-width: 767px)').matches) {
      let useTicking = false;
      const updateActiveByScroll = () => {
        let closest = null;
        let closestDist = Infinity;
        useTabs.forEach(tab => {
          const rect = tab.getBoundingClientRect();
          const dist = Math.abs(rect.top + rect.height / 2 - window.innerHeight / 2);
          if (dist < closestDist) { closestDist = dist; closest = tab; }
        });
        if (closest) {
          useTabs.forEach(t => t.classList.toggle('active', t === closest));
        }
        useTicking = false;
      };
      const onUseScroll = () => { if (!useTicking) { requestAnimationFrame(updateActiveByScroll); useTicking = true; } };
      window.addEventListener('scroll', onUseScroll, { passive: true });
      window.addEventListener('resize', onUseScroll, { passive: true });
      updateActiveByScroll();
    }
  }

  // ── Recipe filters (multi-tag aware) ─────────────────────────
  const filterBtns = document.querySelectorAll('.recipe-filter-btn');
  const recipeCards = document.querySelectorAll('.recipe-card[data-cats]');
  if (filterBtns.length) {
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const cat = btn.dataset.cat;
        const featured = document.querySelector('[data-featured-block]');
        if (featured) featured.style.display = (cat === 'All') ? '' : 'none';
        recipeCards.forEach(card => {
          const cats = (card.dataset.cats || '').split(',').map(s => s.trim());
          card.style.display = (cat === 'All' || cats.includes(cat)) ? '' : 'none';
        });
      });
    });
  }

  // ── Newsletter form (Klaviyo / Shopify customers) ────────────
  const emailForms = document.querySelectorAll('.newsletter-form');
  emailForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]').value;
      const btn   = form.querySelector('button[type="submit"]');
      if (!email) return;
      btn.textContent = 'Done ✓';
      btn.disabled = true;
      // Shopify will handle via form action if action attr is set
      // This is a fallback for display purposes
    });
  });

  // ── Contact form ─────────────────────────────────────────────
  const contactForm = document.querySelector('.contact-form-el');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      // Shopify will handle this via the action="/contact" POST
      // We just add a loading state
      const btn = contactForm.querySelector('[type="submit"]');
      if (btn) btn.textContent = 'Sending…';
    });
  }

  // ── Upcycle idea buttons (swap portrait image) ───────────────
  document.querySelectorAll('[data-upcycle-group]').forEach(group => {
    const buttons = group.querySelectorAll('.pdp-upcycle__idea');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const img = btn.dataset.upcycleImg;
        const target = document.getElementById(btn.dataset.upcycleTarget);
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (img && target && target.tagName === 'IMG') {
          target.style.opacity = '0';
          setTimeout(() => { target.src = img; target.style.opacity = '1'; }, 200);
        }
      });
    });
  });

  // ── Review carousel (product page) ───────────────────────────
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reviewCarousel = document.querySelector('[data-review-carousel]');
  if (reviewCarousel) {
    const slides = reviewCarousel.querySelectorAll('.pdp-review-slide');
    const dots = reviewCarousel.querySelectorAll('.pdp-review-dot');
    let current = 0;
    const show = (i) => {
      slides.forEach((s, idx) => s.classList.toggle('active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('active', idx === i));
      current = i;
    };
    dots.forEach(dot => dot.addEventListener('click', () => show(parseInt(dot.dataset.dot))));
    if (slides.length > 1 && !reduceMotion) {
      setInterval(() => show((current + 1) % slides.length), 6000);
    }
  }

  // ── Parallax (scroll-based, lightweight) ────────────────────
  const parallaxEls = document.querySelectorAll('[data-parallax]');
  if (parallaxEls.length && !reduceMotion) {
    let ticking = false;
    const updateParallax = () => {
      parallaxEls.forEach(el => {
        const speed  = parseFloat(el.dataset.parallax) || 0.1;
        const rect   = el.getBoundingClientRect();
        const center = rect.top + rect.height / 2 - window.innerHeight / 2;
        el.style.transform = `translate3d(0, ${(-center * speed).toFixed(1)}px, 0)`;
      });
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { requestAnimationFrame(updateParallax); ticking = true; } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateParallax();
  }

  // ── Brand strip — continuous mobile parallax (sides rise, middle drops) ─
  const brandEls = document.querySelectorAll('[data-brand-enter]');
  if (brandEls.length && !reduceMotion && window.matchMedia('(max-width: 767px)').matches) {
    let brandTicking = false;
    const updateBrandParallax = () => {
      brandEls.forEach(el => {
        const dir = el.dataset.brandEnter === 'down' ? -1 : 1;
        const rect = el.getBoundingClientRect();
        const center = rect.top + rect.height / 2 - window.innerHeight / 2;
        const offset = Math.max(-140, Math.min(140, -center * 0.5 * dir));
        el.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)`;
      });
      brandTicking = false;
    };
    const onBrandScroll = () => { if (!brandTicking) { requestAnimationFrame(updateBrandParallax); brandTicking = true; } };
    window.addEventListener('scroll', onBrandScroll, { passive: true });
    window.addEventListener('resize', onBrandScroll, { passive: true });
    updateBrandParallax();
  }

  // ── Testimonials — mobile typewriter effect (plays in sequence) ─
  const twQuotes = document.querySelectorAll('[data-typewriter]');
  if (twQuotes.length && !reduceMotion && window.matchMedia('(max-width: 767px)').matches) {
    const typeOne = (el) => {
      return new Promise((resolve) => {
        const full = el.dataset.fullText || '';
        const textSpan = el.querySelector('.tw-text');
        const cursor = el.querySelector('.tw-cursor');
        if (!textSpan) { resolve(); return; }
        textSpan.textContent = '';
        let i = 0;
        const speed = 32;
        const type = () => {
          if (i <= full.length) {
            textSpan.textContent = full.slice(0, i);
            i++;
            setTimeout(type, speed);
          } else {
            if (cursor) cursor.remove();
            resolve();
          }
        };
        type();
      });
    };
    const playSequence = async () => {
      for (const el of twQuotes) {
        await typeOne(el);
        await new Promise((r) => setTimeout(r, 250));
      }
    };
    const twObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          playSequence();
          twObserver.disconnect();
        }
      });
    }, { threshold: 0.3 });
    twObserver.observe(twQuotes[0]);
  }

  // ── Tilt (3D card tilt on mouse, Lovable Tilt component) ────
  const tiltEls = document.querySelectorAll('[data-tilt]');
  if (tiltEls.length && !reduceMotion && window.matchMedia('(hover: hover)').matches) {
    tiltEls.forEach(el => {
      el.style.transformStyle = 'preserve-3d';
      el.style.transition = 'transform 200ms ease-out';
      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = `perspective(800px) rotateX(${(-py * 5).toFixed(2)}deg) rotateY(${(px * 5).toFixed(2)}deg)`;
      });
      el.addEventListener('mouseleave', () => {
        el.style.transform = 'perspective(800px) rotateX(0) rotateY(0)';
      });
    });
  }

  // ── Magnetic (button drifts toward cursor, Lovable Magnetic) ─
  const magneticEls = document.querySelectorAll('[data-magnetic]');
  if (magneticEls.length && !reduceMotion && window.matchMedia('(hover: hover)').matches) {
    magneticEls.forEach(el => {
      el.style.transition = 'transform 250ms cubic-bezier(.2,.7,.2,1)';
      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const mx = e.clientX - (r.left + r.width / 2);
        const my = e.clientY - (r.top + r.height / 2);
        el.style.transform = `translate(${(mx * 0.2).toFixed(1)}px, ${(my * 0.3).toFixed(1)}px)`;
      });
      el.addEventListener('mouseleave', () => { el.style.transform = 'translate(0,0)'; });
    });
  }

  // ── Active nav link highlight ────────────────────────────────
  const path = window.location.pathname;
  document.querySelectorAll('.site-nav__links a, .mobile-menu__links a').forEach(a => {
    if (a.getAttribute('href') === path) {
      a.classList.add('active');
    }
  });

});
